import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ChannelModel } from '../../shared/models/channel';
import { GeographyModel } from '../../shared/models/geography';
import { MysteryTemplateModel } from '../../shared/models/mystery-shopper';
import { RegionModel } from '../../shared/models/region';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { GeographyProvider } from '../../shared/providers/geography.provider';
import { RegionProvider } from '../../shared/providers/region.provider';
import { RolesProvider } from '../../shared/providers/roles.provider';
import { StateProvider } from '../../shared/providers/state.provider';

@Component({
  selector: 'app-mysteryshopper-templates',
  templateUrl: './mysteryshopper-templates.component.html',
  styleUrls: ['./mysteryshopper-templates.component.scss']
})
export class MysteryshopperTemplatesComponent implements OnInit {

  mysteryTemplate: MysteryTemplateModel[];
  getPaginationCount;
  page: any = 1;
  formGroup;
  deletePopupUiData;
  addOrEditLanguage: string;
  regions: RegionModel[];
  geography: GeographyModel[];
  channels: ChannelModel[];
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private route: Router,
    public alertService: AlertService,
    public regionProviders: RegionProvider,
    public stateProviders: StateProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,
    private rolesProvider: RolesProvider,
  ) { }

  ngOnInit() {
    this.getAllmysteryTemplate();
  }

  ngDoCheck() {
    this.regions = this.regionProviders.regions;
    this.channels = this.channelProviders.channels;
    this.geography = this.geoProviders.geography;
  }

  getAllmysteryTemplate() {
    this.apiService.getHeaders(this.apiConfig.getAllmysteryTemplate + "?page=" + this.page)
      .subscribe((res: any) => {
        this.mysteryTemplate = res.body.data;
        this.getPaginationCount = res.headers.get(
          "X-Pagination-Total-Count"
        );
        if (this.mysteryTemplate.length > 0) {
          this.mysteryTemplate.forEach((item) => {
            if (item.status == 1) {
              item.statusString = "Active";
            } else {
              item.statusString = "Inactive";
            }

            item.show = false;
            item.statusString = (item.status == 1) ? "Active" : "Inactive";
            if (new Date(item.start_date) >= new Date()) {
              item.show = true;
            }
          });
        }
      }, err => {
        console.log(err);
      })
  }
  changeStatus(item: MysteryTemplateModel) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updatemysteryTemplate + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
        this.getAllmysteryTemplate();
      });
  }


  showlanguageModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }
  goToAdd(data?) {
    this.route.navigate(["/", "hubAdmin", "add-edit-mystery-template", data.id]);
  }
  paginationClick(pageNumber) {

    this.page = pageNumber;
    this.getAllmysteryTemplate();
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

}
